export default __webpack_public_path__ + "static/media/Section Presentation Image.4ec543da.jpg";